import React from 'react'

const HeaderTwoTop = () => {
  return (
    <div className="header-top-bar text-white d-none d-sm-block">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-9 col-sm-9">
                        <ul className="top-left-content">
                            <li><i className="flaticon-paper-plane"></i> info@shreegita.com</li>
                            <li><i className="flaticon-map"></i>Panchasar Road, Morbi–363641, (Guj.) INDIA</li>
                        </ul>
                    </div>
                    <div className="col-lg-2 col-sm-3 text-end">
                        <div className="top-social-icons">
                          <a href="https://www.facebook.com/pages/Shree-Gita/167373366644608/" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="https://www.linkedin.com/company/shree-gita-group/posts" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-linkedin"></i>
                          </a>
                          <a href="https://www.instagram.com/shreegitaoil/" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-instagram"></i>
                          </a>                
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default HeaderTwoTop